export const INTAKE_SKIP_INITIAL_IMPORT_COPY = {
  label: "Import existing items",
} as const;
